<template>
  <div class="mt-5 md:mt-8">
    <div class="container no-print">
      <LayoutColumns>
        <template #left>
          <AdsConceptAd
            v-if="isSite('altinget_dk')"
            class="lg:hidden order-2"
            id="altinget-mob2"
          />
          <ListQA
            v-if="isPaper('hovedstaden')"
            class="order-9 lg:order-none"
            :count="3"
            label="RaadhusQA"
            label-link="Routes.Raadhussvar"
            :type-id="4"
            placement="side"
          />
          <ListNames
            v-if="isSite('altinget_se', 'altinget_no')"
            class="order-4 lg:order-none"
            :count="5"
            placement="side"
          />
          <ListArticles
            v-else-if="isPaper('christiansborg')"
            class="order-last lg:order-none"
            :count="5"
            :offset="0"
            :subject="6618"
            type="subject"
            label="Risbjergsnittet"
            placement="side"
          />
          <template v-else-if="isPaper('eu', 'sundhed')">
            <ListQA
              class="order-last lg:order-none"
              :count="3"
              placement="side"
              label="MinisterQA"
              label-link="Routes.QA"
            />
            <ListArticles
              class="order-last lg:order-none"
              :count="3"
              :offset="0"
              type="articletype"
              :article-type="115"
              label="Podcast"
              :same-size="true"
              link="/podcast"
              link-label="ShowAll"
              placement="side"
            />
          </template>
          <ListQA
            v-else
            class="order-9 lg:order-none"
            placement="side"
            label="MinisterQA"
            label-link="Routes.QA"
          />
          <AdsConceptAd class="hidden lg:block" id="altinget-rec1" />
          <ListNames
            v-if="isPaper('christiansborg')"
            class="order-last lg:order-none"
            :count="3"
            placement="side"
          />
          <ListQA
            v-else-if="isSite('altinget_no')"
            class="order-last lg:order-none"
            :count="5"
            placement="side"
            label="MinisterQA"
            label-link="Routes.QA"
          />
          <CommonUserWidget class="order-12 lg:order-none" placement="side" />
        </template>
        <template #main>
          <CommonPaywall class="order-3 lg:order-none" placement="main" />
          <ListArticles
            class="order-3 lg:order-none"
            :count="0"
            :frontend="true"
            :lazy="false"
            :preload-first-image="true"
            placement="main"
          />
          <ArticleSponsoredInlineTeaser
            v-if="isSite('altinget_no')"
            class="order-4 lg:order-none"
          />
          <ArticleSponsoredTeaser v-else class="order-3 lg:order-none" />
          <ListBubbles
            v-if="isSite('altinget_dk')"
            class="order-1 lg:order-none"
          />
        </template>
        <template #right>
          <CommonEditorCard class="order-1 lg:order-none" />
          <AdsConceptAd
            v-if="isSite('altinget_se', 'altinget_no')"
            class="lg:hidden order-2"
            id="altinget-mob2"
          />
          <ListJobs class="order-5 lg:order-none" :count="5" :random="true" />
          <ListArticles
            v-if="isSite('altinget_dk') && !isPaper('eu', 'forsvar', 'sundhed')"
            class="order-8 lg:order-none"
            :count="3"
            :offset="0"
            type="articletype"
            :article-type="115"
            label="Podcast"
            :same-size="true"
            link="/podcast"
            link-label="ShowAll"
            placement="side"
          />
          <AdsConceptAd
            class="lg:hidden"
            :class="isSite('altinget_dk') ? 'order-4' : 'order-9'"
            id="altinget-mob3"
          />
          <AdsConceptAd class="hidden lg:block" id="altinget-rec2" />
          <ListColumnists
            v-if="isPaper('christiansborg')"
            class="order-last lg:order-none"
            :count="3"
          />
          <ListCalendar
            v-else
            class="order-last lg:order-none"
            :count="5"
            placement="side"
          />
        </template>
      </LayoutColumns>
    </div>

    <CommonSectionLabel
      class="no-print order-10 lg:order-none"
      title="Birthdays"
      link="Routes.Birthdays"
      link-label="ShowAll"
      :link-to-paper="true"
    />
    <ListBirthdays
      class="no-print order-11 lg:order-none"
      :count="15"
      type="slider"
      placement="full"
    />
    <AdsConceptAd
      class="no-print hidden lg:block"
      id="altinget-lb2"
      :full-width="true"
    />
    <AdsConceptAd
      class="no-print lg:hidden order-last"
      id="altinget-mob4"
      :full-width="true"
    />

    <template v-if="isSite('altinget_dk')">
      <CommonSectionLabel class="no-print hidden lg:block" title="NamesNews" />
      <div class="container no-print">
        <LayoutColumns>
          <template #left>
            <AdsConceptAd class="no-print lg:hidden" id="altinget-mob5" />
            <ListCalendar
              v-if="isPaper('christiansborg')"
              class="order-last lg:order-none"
              :count="5"
              placement="side"
            />
          </template>
          <template #main>
            <ListNames
              class="order-7 lg:order-none"
              placement="main"
              :count="8"
              :show-more="true"
            />
          </template>
          <template #right>
            <ListMostRead class="order-18 lg:order-none" />
            <AdsConceptAd class="hidden lg:block" id="altinget-rec3" />
          </template>
        </LayoutColumns>
      </div>
      <ListJobs
        class="no-print hidden lg:block"
        :count="15"
        :is-slider="true"
      />
      <AdsConceptAd
        class="no-print hidden lg:block"
        id="altinget-lb3"
        :full-width="true"
      />
    </template>
    <CommonSectionLabel
      class="no-print order-19 lg:order-none"
      title="Debate"
    />
    <div class="container no-print">
      <LayoutColumns>
        <template #left>
          <ListJobs
            v-if="isPaper('civilsamfund', 'eu', 'forsvar', 'hovedstaden')"
            class="order-last lg:order-none"
          />
          <AdsConceptAd
            v-if="isSite('altinget_dk')"
            class="hidden lg:block"
            id="altinget-rec4"
          />
          <ListCalendar
            v-if="isSite('altinget_se')"
            class="order-14 lg:order-none"
            title="Aktuella remisser"
            type="2"
            :count="5"
            placement="side"
          />

          <AdsConceptAd
            v-if="isSite('altinget_no')"
            class="lg:hidden"
            id="altinget-mob5"
          />
          <ListArticles
            v-if="isSite('altinget_no')"
            class="order-27 lg:order-none"
            :count="5"
            :offset="0"
            :paper="1"
            label="FrontpageNow"
            type="instream"
            placement="side"
          />
        </template>
        <template #main>
          <ListArticles
            v-if="isPaper('christiansborg')"
            class="order-last lg:order-none"
            :count="4"
            :offset="0"
            type="articletype"
            :article-type="14"
            placement="main"
          />
          <ListArticles
            v-else
            class="order-20 lg:order-none"
            :count="4"
            :offset="0"
            type="column"
            :show-more="true"
            placement="main"
          />
        </template>
        <template #right>
          <AdsConceptAd
            v-if="isSite('altinget_dk')"
            class="hidden lg:block"
            id="altinget-rec5"
          />
          <AdsConceptAd
            v-if="isSite('altinget_se')"
            class="lg:hidden"
            id="altinget-mob5"
          />
          <ListArticles
            v-if="isSite('altinget_dk') && !isPaper('christiansborg')"
            class="order-28 lg:order-none"
            :count="5"
            :offset="0"
            type="articletype"
            :article-type="100"
            label="Comment"
            :same-size="true"
            placement="side"
          />
          <ListArticles
            v-else-if="isSite('altinget_se')"
            class="lg:order-none"
            :count="5"
            :offset="0"
            :article-type="71"
            type="articletype"
            label="AnalysesFrom"
            :same-size="true"
            placement="side"
          />
        </template>
      </LayoutColumns>
    </div>
    <template v-if="isSite('altinget_se', 'altinget_no')">
      <CommonSectionLabel class="no-print hidden lg:block" title="NamesNews" />
      <div class="container no-print">
        <LayoutColumns>
          <template #left>
            <ListMostRead class="order-18 lg:order-none" />
            <AdsConceptAd class="hidden lg:block" id="altinget-rec4" />
          </template>
          <template #main>
            <ListNames
              class="order-7 lg:order-none"
              placement="main"
              :count="5"
            />
          </template>
          <template #right>
            <ListArticles
              v-if="isSite('altinget_se')"
              class="order-21 lg:order-none"
              :count="3"
              :offset="0"
              :article-type="90"
              type="articletype"
              label="Chronicles"
              :same-size="true"
              placement="side"
            />
            <ListArticles
              v-else-if="isSite('altinget_no')"
              class="order-21 lg:order-none"
              :count="3"
              :offset="0"
              :article-type="72"
              label="Spaltister"
              :same-size="true"
              type="articletype"
              placement="side"
            />
          </template>
        </LayoutColumns>
      </div>
    </template>
    <template
      v-if="isSite('altinget_dk', 'altinget_se') && !isPaper('christiansborg')"
    >
      <CommonSectionLabel
        class="no-print order-15 lg:order-none"
        title="DecisionChain"
        link="decisionchain/"
      />
      <ListDecisionchains
        class="no-print order-16 lg:order-none"
        :count="15"
        type="slider"
        placement="full"
      />
    </template>
    <div class="container no-print">
      <LayoutColumns>
        <template #left>
          <AdsConceptAd
            v-if="isSite('altinget_dk')"
            :id="`${config.public.site.ads?.placementPrefix}-mkt-promo1`"
            class="order-26 lg:order-none"
          />
          <template v-if="isSite('altinget_no')">
            <ListArticles
              class="order-28 lg:order-none"
              :count="5"
              :offset="0"
              :article-type="71"
              type="articletype"
              label="Analyser fra Altinget"
              :same-size="true"
              placement="side"
            />
            <ListArticles
              class="order-last lg:order-none"
              :count="5"
              :offset="0"
              :article-type="6"
              type="articletype"
              :rss="true"
              label="NewsParties"
              link-label="Routes.RSSList"
              :same-size="true"
              placement="side"
            />
          </template>
          <ListArticles
            v-else
            class="order-27 lg:order-none"
            :count="5"
            :offset="0"
            :paper="1"
            label="FrontpageNow"
            type="instream"
            placement="side"
          />
        </template>
        <template #main>
          <ListArticles
            class="hidden lg:block"
            :count="8"
            :offset="0"
            type="instream"
            :show-more="true"
            :article-type="0"
            placement="main"
          />
          <ListArticles
            v-if="isSite('altinget_se')"
            class="order-last lg:order-none"
            :count="5"
            :offset="0"
            :article-type="6"
            type="articletype"
            :rss="true"
            label="NewsParties"
            link-label="Routes.RSSList"
            :same-size="true"
            placement="side"
          />
        </template>
        <template #right>
          <ListNames
            v-if="isPaper('christiansborg')"
            class="order-last lg:order-none"
            :count="3"
            placement="side"
          />
          <AdsConceptAd
            v-if="isSite('altinget_no', 'altinget_se')"
            class="hidden lg:block"
            id="altinget-rec5"
          />
          <ListJobs class="order-23 lg:order-none" />
          <ListArticles
            v-if="isSite('altinget_se')"
            class="order-last lg:order-none"
            :count="5"
            :offset="0"
            :article-type="24"
            type="articletype"
            :rss="true"
            label="NewsOtherMedia"
            link-label="Routes.RSSList"
            :same-size="true"
            placement="side"
          />
          <ListArticles
            v-else-if="isSite('altinget_no')"
            class="order-last lg:order-none"
            :count="5"
            :offset="0"
            :article-type="24"
            type="articletype"
            :rss="true"
            label="Nyheter fra andre spillere"
            link-label="Routes.RSSList"
            :same-size="true"
            placement="side"
          />
        </template>
      </LayoutColumns>
    </div>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()

const indexStore = useIndexStore()

type CustomPaperSlug =
  | 'christiansborg'
  | 'civilsamfund'
  | 'eu'
  | 'forsvar'
  | 'hovedstaden'
  | 'sundhed'

// Helper for custumized papers on Altinget.dk
const isPaper = (...slugs: CustomPaperSlug[]) => {
  if (!isSite('altinget_dk')) return false
  if (!indexStore.currentPaperSlug) return false

  return (slugs as string[]).includes(indexStore.currentPaperSlug)
}

if (!indexStore.currentPaper) {
  throw createError({ statusCode: 404 })
}

useSeoMeta({
  title: indexStore.currentPaperSlug
    ? config.public.site.meta.title.postfix.short +
      indexStore.currentPaper?.Name
    : config.public.site.meta.title.postfix.long,
})
</script>
